var index = 0;
export var generateID = function () {
    return (index += 1);
};
//# sourceMappingURL=uid.js.map